import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoopinionReducer(state= initialState.cursoopinion, action){
    let newState;
	switch(action.type){
         case types.LOAD_CURSOOPINION_LIST_SUCCESS:		
            action.cursoopinion.filtroActivo=state.filtroActivo;
            action.cursoopinion.filtroActual=state.filtroActual;
            action.cursoopinion.showActivos=state.showActivos;
			 action.cursoopinion.paginaActual=action.cursoopinion.pageable.pageNumber;
			 action.cursoopinion.registrosPorPagina=action.cursoopinion.size;
            
            return action.cursoopinion;

        case types.BORRAR_CURSOOPINION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoopinion => cursoopinion.id !== action.cursoopinion.id)];          
			return newState;    
            
        case types.ACTIVAR_CURSOOPINION_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoopinion => cursoopinion.id !== action.cursoopinion.id)];          
			 return newState;
            
        case types.SET_FILTRO_CURSOOPINION:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}